import React from "react";

export default function GeoDebugPage() {
  return (
    <div style={{ padding: 16 }}>
      <h2>Geo Debug</h2>
      <p>Funkcionalita geo debug будет implementována позже</p>
    </div>
  );
}
